import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import classes from './Social.module.css';
import { data } from './SocialData';

const Icon = (width, y) => {
  return data.map((icon, i) => {
    return (
      <li key={i} className={classes.social_icon}>
        {icon.name === 'Whatsapp' ? (
          <Link
            to="/unknown"
            // target="_blank"
            className={classes.social_link}
          >
            <img
              style={{ width: width }}
              className={classes.social_img}
              src={icon.img}
              alt="aaaaa"
            ></img>
          </Link>
        ) : icon.name === 'Spotify' ? (
          <Link
            to="/spotify"
            // target="_blank"
            className={classes.social_link}
          >
            <img
              style={{ width: width }}
              className={classes.social_img}
              src={icon.img}
              alt="aaaaa"
            ></img>
          </Link>
        ) : (
          <a
            href={icon.link}
            target="_blank"
            rel="noreferrer"
            className={classes.social_link}
          >
            <img
              style={{ width: width }}
              className={classes.social_img}
              src={icon.img}
              alt="adnak"
            ></img>
          </a>
        )}

        <span
          style={{
            transform: `translateY(${y}px)`,
            color: icon.color
          }}
          className={classes.icon_text}
        >
          {icon.name}
        </span>
      </li>
    );
  });
};

const Social = ({ width, y = '-20' }) => {
  // const handleClick = (icon) => {};
  return (
    <>
      <div className={classes.social}>
        <ul className={classes.social_icons_list}>{Icon(width, y)}</ul>
      </div>
    </>
  );
};

export default memo(Social);
